import { useFormContext } from 'react-hook-form'
import { TextField } from '@boltenergy-be/design-system'
import { getFieldError, getFieldName } from 'components/inputs/utils'
import { MeterReadingProps } from 'components/inputs/meter-reading/types'
import { useTranslation } from 'next-i18next/pages'
import { isValidEAN } from 'utils/helpers'

const MeterReading = ({ fieldKey, parentDotPath }: MeterReadingProps) => {
  // React Hook Form
  const {
    formState: { errors },
    register
  } = useFormContext()

  // i18n
  const { t } = useTranslation(['commonFormFields', 'validation'])

  return (
    <TextField
      {...register(getFieldName(fieldKey, parentDotPath), {
        min: {
          value: 0,
          message: t('validation:min.number', {
            attribute: t('commonFormFields:meterReading.label'),
            value: 0
          })
        },
        required: t('validation:required'),
        validate: (value: number) => !isValidEAN(value.toString(10)) || t('commonFormFields:meterReading.errors.looksLikeEan')
      })}
      error={getFieldError(fieldKey, parentDotPath, errors)?.message}
      label={`${t('commonFormFields:meterReading.label')}${fieldKey !== 'total' ? ` ${t(`commonFormFields:meterReading.${fieldKey}`)}` : ''}`}
      min={0}
      step={1}
      suffix={{ as: ',000' }}
      type="number"
    />
  )
}

export default MeterReading
